import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import { GenericModal } from "../../GenericModal/GenericModal";
import { EditRecordModal } from "..";
import { DataTable } from "../../DataTable";
import { delay, exportData, Message } from "../../../utils";
import { RecordDataColums } from "../../../constants";
import { StatusWindow } from "../../OrderInfo/DeliveryStatus/StatusWindow";

import { getOrders, updateOrderDeliver } from "../../../service/api/Order/apiOrder";
import { deleteDeliveryRedcord } from "../../../service/api/DeliveryRecord/apiDeliveryRecord";

const RecordSheet = ({ data }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const [recordsData, setRecordsData] = useState([]);
    const [editRecord, setEditRecord] = useState(false);
    const [statusFilter, setStatusFilter] = useState(urlParams.get("status") ?? 'all'); // 寄送狀態
    const [filterText, setFilterText] = useState("");
    const [orderDeliveryStatus, setOrderDeliveryStatus] = useState(null); // 放當前查看訂單狀態的資料用
    const [dateRange, setDateRange] = useState({ start: urlParams.get("start") ?? "", end: urlParams.get("end") ?? "" });
    const [selectedRows, setSelectedRows] = useState([]); // 儲存勾選的紀錄 id
    const [showColumnSelector, setShowColumnSelector] = useState(false); // 篩選區域顯示開關

    const filteredItems = useMemo(() => {
        return recordsData.filter(item => {
            // 文字搜尋
            const matchText =
                item.deliverName?.includes(filterText) ||
                String(item.id)?.includes(filterText) ||
                item.orderId?.includes(Number(filterText))

            // 完成狀態篩選
            const matchStatus =
                statusFilter === 'all' ||
                (statusFilter === 'finish' && item.status) ||
                (statusFilter === 'undone' && !item.status);

            // 日期篩選
            let matchDate = true;
            if (dateRange.start || dateRange.end) {
                const itemDate = new Date(item.deliveryDate);
                const startDate = dateRange.start ? new Date(dateRange.start) : null;
                const endDate = dateRange.end ? new Date(dateRange.end) : null;

                if (startDate && itemDate < startDate) matchDate = false;
                if (endDate && itemDate > endDate) matchDate = false;
            }

            // return matchID && matchText && matchStatus && matchReview && matchDate;
            return matchText && matchStatus && matchDate;
        });
    }, [recordsData, statusFilter, filterText, dateRange]);


    useEffect(() => {
        if (data) {
            console.log(data);
            setRecordsData(data);
        }
    }, [data]);

    const allColumns = [
        {
            name: "選擇(未開啟為全選)", cell: row => (
                <label className="small-btn">
                    <input
                        type="checkbox"
                        checked={selectedRows.includes(row.id)} // 手動勾選才生效
                        onChange={e => {
                            if (!selectedRows.includes(row.id)) {
                                setSelectedRows(prev => [...prev, row.id]);
                            } else {
                                setSelectedRows(prev => prev.filter(id => id !== row.id));
                            }
                        }}
                    />
                </label>
            ), key: "check"
        },
        ...RecordDataColums
        ,
        {
            name: "操作",
            cell: row =>
                <div className="row-actions">
                    {/* <a className="btn btn-success btn-sm" href="/SKAManager/OrderInfo">查看</a> */}
                    <button className="btn btn-action--dark btn-action--sm" onClick={() => setOrderDeliveryStatus(row)} >運送狀態</button >
                    <Link
                        className="btn btn-action--confirm btn-action--sm"
                        to={`/SKAManager/OrderInfo?id=${row.orderId.map(id => `${id}`).join(",")}`}
                    >
                        查看
                    </Link>
                    <button className="btn btn-action--primary btn-action--sm" onClick={() => setEditRecord(row)} >編輯</button>
                    <button className="btn btn-action--danger btn-action--sm" onClick={() => handleDeletedRecord(row)} >刪除</button>
                </div>,
            key: "action"
        }
    ];
    const [selectedColumns, setSelectedColumns] = useState(
        allColumns
            .map(col => col.key)
            .filter(key => /*key !== "addressDistrict" &&*/ key !== "check") // 預設不勾選 區、check
    );
    const toggleColumn = key => setSelectedColumns(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
    const columnsToShow = allColumns.filter(col => selectedColumns.includes(col.key));

    const handleDeletedRecord = async (data) => {
        const confirmAction = window.confirm("確定要刪除該紀錄嗎？");
        if (!confirmAction) return;
        console.log(data)
        const response = await deleteDeliveryRedcord({ id: data.id });

        if (response.status === 200) {
            Message('刪除成功');
            await delay(1);
            console.log(response.status);

            const response_t = await updateOrderDeliver({
                deliverId: null,
                deliverName: null,
                orderId: [],
                removedOrderId: data?.orderId,

            });
            if (response_t.status === 200) {
                Message('訂單司機更新成功');
                await delay(1);
                setRecordsData(recordsData.filter(item => item.id !== data.id));
            }
        }
    };

    const handleExcelDownload = () => {
        // 如果沒有顯示 checkbox 欄位，預設全選
        const isCheckColumnVisible = selectedColumns.includes("check");

        const rowsToExport = isCheckColumnVisible
            ? filteredItems.filter(item => selectedRows.includes(item.id)) // 手動勾選
            : filteredItems; // checkbox 不顯示 → 全選

        let columnsToExport = selectedColumns.length > 0
            ? selectedColumns
            : allColumns.map(col => col.key).filter(key => key !== "check" && key !== "action");

        exportData(rowsToExport, columnsToExport, 'deliveryRecord');
    }

    return (
        <>
            <GenericModal isOpen={editRecord}>
                <EditRecordModal
                    data={data}
                    record={editRecord}
                    setRecordsData={setRecordsData}
                    onClose={() => setEditRecord(false)} />
            </GenericModal>
            {/* 運送狀態查看視窗 */}
            <GenericModal
                isOpen={orderDeliveryStatus}
                onClose={() => setOrderDeliveryStatus(null)}
            >
                <StatusWindow
                    deliveryRecord={orderDeliveryStatus}
                    onClose={(e) => { setOrderDeliveryStatus(null); e.preventDefault(); }}
                />
            </GenericModal>
            <div className="card-header d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-2 gap-md-0">
                <div className="d-flex align-items-center">
                    <h6 className="m-0 fw-bold text-primary">
                        <i className="fas fa-table me-2"></i>指派紀錄列表
                    </h6>
                </div>
                <div className="sheet-actions">
                    <input
                        type="text"
                        placeholder="序號、司機、訂單編號"
                        className="form-control ms-2 me-2 mt-3 mb-3"
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        style={{ maxWidth: "200px" }}
                    />
                </div>
            </div>
            {/* 額外篩選區塊 */}
            <div className="card-body border-top sheet-toolbar">
                <div className="sheet_filter_container">
                    {/* 狀態篩選 */}
                    <div className="sheet_filter">

                        {/* 已送達篩選 */}
                        <div className="d-flex gap-1">
                            <button
                                className={`btn btn-action--sm ${statusFilter === 'all' ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                onClick={() => setStatusFilter('all')}
                            >全部</button>
                            <button
                                className={`btn btn-action--sm ${statusFilter === 'finish' ? 'btn-action--confirm' : 'btn-action--neutral btn-action--soft'}`}
                                onClick={() => setStatusFilter('finish')}
                            >已完成</button>
                            <button
                                className={`btn btn-action--sm ${statusFilter === 'undone' ? 'btn-action--warning' : 'btn-action--neutral btn-action--soft'}`}
                                onClick={() => setStatusFilter('undone')}
                            >待完成</button>
                        </div>

                        {/* 日期篩選 */}
                        <div className="date-range-inline">
                            <input
                                type="date"
                                className="form-control"
                                value={dateRange.start}
                                onChange={(e) => setDateRange(prev => ({ ...prev, start: e.target.value }))}
                            />
                            <span>～</span>
                            <input
                                type="date"
                                className="form-control"
                                value={dateRange.end}
                                onChange={(e) => setDateRange(prev => ({ ...prev, end: e.target.value }))}
                            />
                        </div>
                        <div className="sheet-actions">
                            <button
                                className="btn btn-action--neutral btn-action--soft btn-action--sm"
                                onClick={() => setShowColumnSelector(prev => !prev)}
                            >
                                {showColumnSelector ? "收起欄位" : "選擇欄位"}
                            </button>
                            <button
                                className="btn btn-action--primary btn-action--soft"
                                onClick={() => {
                                    handleExcelDownload();
                                }}
                            >
                                <i className="fas fa-download me-2"></i> 匯出Excel資料
                            </button>
                        </div>
                    </div>
                </div>



                <div className="d-flex flex-wrap gap-2 mt-3">
                    {showColumnSelector &&
                        allColumns.map(col => {
                            const isSelected = selectedColumns.includes(col.key);
                            return (
                                <button
                                    key={col.key}
                                    type="button"
                                    className={`btn btn-action--sm ${isSelected ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                    onClick={() => toggleColumn(col.key)}
                                >
                                    {col.name} {isSelected && <span className="badge bg-light text-dark ms-1">✓</span>}
                                </button>
                            )
                        })
                    }
                </div>
            </div>

            <DataTable
                columns={columnsToShow}
                data={filteredItems}
                pagination
                noDataComponent="無此訂單資訊"
                paginationComponentOptions={{
                    rowsPerPageText: '每頁筆數',
                    rangeSeparatorText: '總共',
                }} />

        </>
    );
};

export { RecordSheet };
